import { render, staticRenderFns } from "./AdsComponent.vue?vue&type=template&id=6b9707ea"
import script from "./AdsComponent.vue?vue&type=script&lang=js"
export * from "./AdsComponent.vue?vue&type=script&lang=js"
import style0 from "./AdsComponent.vue?vue&type=style&index=0&id=6b9707ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports